/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Update_Version_DescriptionInputs */

const en_dialog_update_version_description = /** @type {(inputs: Dialog_Update_Version_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please update your app via the app store to enjoy the latest focus event!`)
};

const ar_dialog_update_version_description = /** @type {(inputs: Dialog_Update_Version_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لتجربة اخر احداث التركيز، يرجى التحديث إلى أحدث إصدار في متجر التطبيقات.`)
};

const de_dialog_update_version_description = /** @type {(inputs: Dialog_Update_Version_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um die neuesten Fokusveranstaltungen zu erleben, aktualisieren Sie bitte auf die neueste Version im App Store.`)
};

const es_dialog_update_version_description = /** @type {(inputs: Dialog_Update_Version_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para disfrutar de los últimos eventos, actualiza la app a la última versión en la tienda de aplicaciones.`)
};

const fr_dialog_update_version_description = /** @type {(inputs: Dialog_Update_Version_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pour participer aux derniers évènements, veuillez télécharger la dernière mise à jour depuis le store.`)
};

const it_dialog_update_version_description = /** @type {(inputs: Dialog_Update_Version_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per vivere gli ultimi eventi di concentrazione, aggiorna all'ultima versione disponibile nell'app store.`)
};

const ja_dialog_update_version_description = /** @type {(inputs: Dialog_Update_Version_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいイベントに参加するには、アプリストアで最新バージョンにアップデートしてください。`)
};

const ko_dialog_update_version_description = /** @type {(inputs: Dialog_Update_Version_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`최신 집중 이벤트를 경험하려면 앱스토어에서 최신 버전으로 업데이트하세요.`)
};

const pt_br_dialog_update_version_description = /** @type {(inputs: Dialog_Update_Version_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para participar dos últimos eventos de foco, atualize para a versão mais recente na loja de aplicativos.`)
};

const ru_dialog_update_version_description = /** @type {(inputs: Dialog_Update_Version_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновите приложение в App Store до последней версии, чтобы поучаствовать в новейших событиях по фокусировке.`)
};

const th_dialog_update_version_description = /** @type {(inputs: Dialog_Update_Version_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เพื่อสัมผัสประสบการณ์อีเวนต์การโฟกัสล่าสุด โปรดอัปเดตเป็นเวอร์ชันล่าสุดใน App Store.`)
};

const tr_dialog_update_version_description = /** @type {(inputs: Dialog_Update_Version_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En yeni odaklanma etkinliklerine katılmak için lütfen uygulamayı en son sürüme güncelle.`)
};

const zh_cn_dialog_update_version_description = /** @type {(inputs: Dialog_Update_Version_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为体验最新的专注活动内容，请前往应用商店更新至最新版本`)
};

const zh_tw_dialog_update_version_description = /** @type {(inputs: Dialog_Update_Version_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`為體驗最新的專注活動內容，請到商城更新至最新版本`)
};

/**
* | output |
* | --- |
* | "Please update your app via the app store to enjoy the latest focus event!" |
*
* @param {Dialog_Update_Version_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_update_version_description = /** @type {((inputs?: Dialog_Update_Version_DescriptionInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Update_Version_DescriptionInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_update_version_description(inputs)
	if (locale === "ar") return ar_dialog_update_version_description(inputs)
	if (locale === "de") return de_dialog_update_version_description(inputs)
	if (locale === "es") return es_dialog_update_version_description(inputs)
	if (locale === "fr") return fr_dialog_update_version_description(inputs)
	if (locale === "it") return it_dialog_update_version_description(inputs)
	if (locale === "ja") return ja_dialog_update_version_description(inputs)
	if (locale === "ko") return ko_dialog_update_version_description(inputs)
	if (locale === "pt_br") return pt_br_dialog_update_version_description(inputs)
	if (locale === "ru") return ru_dialog_update_version_description(inputs)
	if (locale === "th") return th_dialog_update_version_description(inputs)
	if (locale === "tr") return tr_dialog_update_version_description(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_update_version_description(inputs)
	return zh_tw_dialog_update_version_description(inputs)
});